import { all } from 'redux-saga/effects';
import authSaga from 'saga/authSaga';
import shopSaga from 'saga/shopSaga';
import shopSettingSaga from 'saga/shopSettingSaga';
import rankingSaga from 'saga/rankingSaga';

export default function* rootSaga() {
  yield all([authSaga(), shopSaga(), shopSettingSaga(), rankingSaga()]);
}
